import history from '../../lib/history';

const replaceHistory = newPath => {
  history.replace(newPath);
};

export default replaceHistory;
